import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccordionVM } from '../accordion/accordion.model';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class SutrapathService {

  constructor(private httpClient: HttpClient) { }

  public getSutra(stype: SutraType): Observable<AccordionVM[]>
  {
    return this.httpClient.get<AccordionVM[]>(Constants.sutra + stype);
  }

  public getdrustant(stype: SutraType): Observable<AccordionVM[]>
  {
    return this.httpClient.get<AccordionVM[]>(Constants.drustant);
  }
}

export enum SutraType
{
  nauprakaran,
  achar,
  acharMalika,
  vichar,
  vicharMalika,
  drustant
}

